module.exports = __webpack_public_path__ + "static/img/rule.5ecae0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fourth/01/rule.png
// module id = +rjq
// module chunks = 1